import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { ErrorHandler } from '../utils/error-handler';
import { LabMDM, SelectableLab } from '../masterdata/models/lab';

import { MessagesService } from '../messages/messages.service';
import { MasterDataService } from '../masterdata/masterdata.service';
import { KitsDTO } from '../masterdata/models/kits-dto';
import { MdmProcessStepService } from '../mdm-process-step/mdm-process-step.service';
@Component({
  selector: 'app-kits-template',
  templateUrl: './kits-template.component.html',
  styleUrls: ['./kits-template.component.css']
})
export class KitsTemplateComponent implements OnInit {

  @Input() masterLists: KitsDTO[];
  @Input() tableCols: any[];
  @Input() title: string;
  @Input() labOptions: LabMDM[];
  @Input() detailCols: any[];
  @Input() checkSelectedLab: SelectableLab;

  labOption: LabMDM[]=[];
  isNewMasterList: boolean;
  masterList: KitsDTO;
  displayMasterListDialog: boolean = false;
  selectedLabName: string;
  selectedLab: LabMDM;
  kitTypeSelected: string;
  errorHandler: ErrorHandler = new ErrorHandler;
  selectedMasterList: KitsDTO;
  entityOptions: any[];
  kits: any[];
  isActive: string = "active";
  isLab: string = "lab";
  isKitsName: string = "kitName";
  isKitType: string = "kitType";
  isRequiredMaterials: string = "requiredMaterials";
  isSwabRestriction: string = "swabRestriction";
  isChannel1Gene: string = "channel1Gene";
  isChannel1File: string = "channel1File";
  isChannel1Dye: string = "channel1Dye";
  isChannel2Gene: string = "channel2Gene";
  isChannel2File: string = "channel2File";
  isChannel2Dye: string = "channel2Dye";
  isChannel3Gene: string = "channel3Gene";
  isChannel3File: string = "channel3File";
  isChannel3Dye: string = "channel3Dye";
  isChannel4Gene: string = "channel4Gene";
  isChannel4File: string = "channel4File";
  isChannel4Dye: string = "channel4Dye";
  isChannel5Gene: string = "channel5Gene";
  isChannel5File: string = "channel5File";
  isChannel5Dye: string = "channel5Dye";
  isProcessingTime: string = "processingTime";
  swabTypeList: any = [];
  swabType: string[] = [];
  kitType: any = [];
  swabRestriction: string[] = [];
  dominantChannelList: any[] = [];
  isDominantChannel: string = "dominantChannel";
  selectedDominantChannel: string;
  machineTypeList: any[];
  subTypes: string[] = [];
  mapOfProcessingTime: Map<string, number> = new Map();
  selectedMachineType: string;

  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService, private _mdmProcessStepService: MdmProcessStepService) { }

  ngOnInit() {
    this.kitType = [
      { value: 'Extraction Kit', label: 'Extraction Kit' },
      { value: 'PCR Kit', label: 'PCR Kit' }
    ];
    this.swabTypeList = [
      { value: 'Dry', label: 'Dry' },
      { value: 'Wet', label: 'Wet' },
      { value: 'Saliva', label: 'Saliva' },
      { value: 'Non standard', label: 'Non standard' },
      { value: 'Mixed', label: 'Mixed' }
    ];
  }

 //Initialize Dropdown and populate it
  populateDominantChannel() {
    this.masterList.dominantChannel = null;
    this.prepareDominantChannelList();
  }

  //Prepare Dropdown for Dominant Channel based on input
  prepareDominantChannelList() {
    this.dominantChannelList = [];
    this.dominantChannelList.push({ value: 'No Channel', label: 'No Channel' })
    if (this.masterList[this.isChannel1Gene])
      this.dominantChannelList.push({ value: this.masterList[this.isChannel1Gene], label: this.masterList[this.isChannel1Gene] })
    if (this.masterList[this.isChannel2Gene])
      this.dominantChannelList.push({ value: this.masterList[this.isChannel2Gene], label: this.masterList[this.isChannel2Gene] })
    if (this.masterList[this.isChannel3Gene])
      this.dominantChannelList.push({ value: this.masterList[this.isChannel3Gene], label: this.masterList[this.isChannel3Gene] })
    if (this.masterList[this.isChannel4Gene])
      this.dominantChannelList.push({ value: this.masterList[this.isChannel4Gene], label: this.masterList[this.isChannel4Gene] })
    if (this.masterList[this.isChannel5Gene])
      this.dominantChannelList.push({ value: this.masterList[this.isChannel5Gene], label: this.masterList[this.isChannel5Gene] })
    }

  //Display master Dialog upon clicked on a row
  onRowSelect(event) {
    this.isNewMasterList = false;
    this.masterList = this.cloneMasterList(event.data);
    this.displayMasterListDialog = true;
    this.selectedLab = null;
    this.selectedLabName = null;
    this.getActiveOptionsForDropdowns();
    this.prepareDominantChannelList();
    this.prepareProcessingTimeMap();
  }

  prepareProcessingTimeMap() {
    if(this.masterList && this.masterList.processingTime){
      this.mapOfProcessingTime = new Map(Object.entries(this.masterList.processingTime));
      this.subTypes = Array.from(this.mapOfProcessingTime.keys());
    }
  }

  //Retrieve the Active lab for dropdown
  getActiveOptionsForDropdowns() {
      this.labOption=[];

    this._masterDataService.getLabs(true).subscribe(
      results => {
        if (!results) {
          return;
        }
        let checkSelectedLabName = this.checkSelectedLab.lab.name;
        this.labOptions = results.data;
        this.labOptions.forEach(lab => {
          if(lab.name == checkSelectedLabName) {
            this.labOption.push(lab);
          }
          if (this.masterList && this.masterList.lab && lab._id == this.masterList.lab._id) {
            this.selectedLabName = this.masterList.lab.name;
            this.selectedLab = lab;
          }
        })
        this.labOptions = this.labOption;
        if (!this.masterList || !this.masterList.lab || this.selectedLabName != this.masterList.lab.name)
          this.selectedLab = null;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );

   if(this.masterList.lab){
     this.selectedLab = this.masterList.lab;
    this.onLabSelect();
   }
  }

  //Display Add Dialog upon clicking Add button
  showDialogToAddMasterList() {
    this.isNewMasterList = true;
    this.masterList = new KitsDTO;
    this.displayMasterListDialog = true;
    this.getActiveOptionsForDropdowns();
    this.selectedLab = null;
    this.prepareDominantChannelList();
  }

  cloneMasterList(list: any): any {
    let masterList = {};
    for (let prop in list) {
      masterList[prop] = list[prop];
    }
    return masterList;
  }

  //Insert or update Template
  saveMasterList() {
    let masterLists = [...this.masterLists];
    if (this.isChannelPresent() && !this.masterList.dominantChannel) {
      this._messageService.addErrorMessage({ severity: 'error', summary: 'Dominant Channel Empty', detail: 'Please select Dominant Channel' });
      return;
    }
    if (this.isNewMasterList) {
      this.saveMasterData(masterLists);
    }
    else {
      this.updateMasterData(masterLists);
    }
  }

  //Checks if any one of the channel is present in the Kit
  isChannelPresent() {
    return (this.masterList.channel1Gene || this.masterList.channel2Gene || this.masterList.channel3Gene || this.masterList.channel4Gene || this.masterList.channel5Gene)
  }

  //Inserts a new Template in DB
  saveMasterData(masterLists: any[]) {
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.masterList.machineType =this.selectedMachineType;
    if(this.mapOfProcessingTime){
      this.masterList.processingTime = new Map();
      this.mapOfProcessingTime.forEach((v: number, k: string) => {
        this.masterList.processingTime[k] = v;
      });
    }
    this._masterDataService.addKit(this.masterList).subscribe(
      results => {
        if (!results) {
          return;
        }
        masterLists = [...this.masterLists];
        masterLists.push(results.data);
        this.masterLists = masterLists;
        this.masterList = null;
        this.displayMasterListDialog = false;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  //Updates a Template in DB
  updateMasterData(masterLists: any[]) {
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.masterList.machineType =this.selectedMachineType;
    this.masterList.processingTime = new Map();
    if(this.mapOfProcessingTime){
      this.masterList.processingTime = new Map();
      this.mapOfProcessingTime.forEach((v: number, k: string) => {
        this.masterList.processingTime[k] = v;
      });
    }
    this._masterDataService.updateKit(this.masterList).subscribe(
      results => {
        if (!results) {
          return;
        }
        masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
        this.masterLists = masterLists;
        this.masterList = null;
        this.displayMasterListDialog = false;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  onLabSelect() {
    this.machineTypeList = [];
    this._mdmProcessStepService.getMachineTypesByLab(this.selectedLab, true).subscribe(
      results => {
        if (!results) {
          return;
        }

        results.data.forEach(type => {
          this.machineTypeList.push({ label: type.name, value: type.name });
          if (this.masterList && this.masterList.machineType && type.name == this.masterList.machineType) {
            this.selectedMachineType = type.name;
          }
        });
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  getsubTypesForMachineType(){
    this._masterDataService.getMachineSubTypes(this.selectedMachineType, this.selectedLab._id).subscribe(
      results => {
        this.subTypes = results.data;
        this.mapOfProcessingTime = new Map();
        results.data.forEach(subType => {
          if(this.masterList.machineType != this.selectedMachineType)
            this.mapOfProcessingTime.set(subType,0);
          else
            this.mapOfProcessingTime.set(subType, this.masterList.processingTime[subType]);
        });
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  setProcessingTime(subtype: string, event){
    this.mapOfProcessingTime.set(subtype, event);
  }

  clearCache(){
    this.mapOfProcessingTime = null;
    this.subTypes = null;
    this.selectedMachineType = null;
  }

  //Check if the Template Name or Lab is Entered or not, if not disable Save button
  isSaveDisabled() {
    return !this.masterList || !this.masterList.kitName || !this.masterList.requiredMaterials;
  }
}


